import React from "react";

export default function MyIslandLayer({
  isMyIsland,
  VIEWPORT_WIDTH,
  VIEWPORT_HEIGHT,
  camX,
  camY,
  placingDecor,
  decorMoveMode,
  selectedMovePlacementId,
  decorRemoveMode,
  trainerNpcMode,
  gameCornerNpcMode,
  handlePlacementMouseMove,
  handlePlacementMapClick,
  handleTrainerNpcMapClick,
  handleGameCornerNpcMapClick,
  sortedDecorPlacements,
  myIslandZBase,
  berryShopPower,
  receiverPowerModalOpen,
  receiverPowerStatus,
  receiverWorldPowerStatus,
  selectedRemovalPlacementId,
  ownedTrainerNpcs,
  ownedGameCornerNpcs,
  handleHutClickForAssignment,
  setSelectedRemovalPlacementId,
  setSelectedMovePlacementId,
  setMovingDecor,
  setDrillPlacementId,
  setDrillModalOpen,
  setActiveBerryFusionStationId,
  setShowBerryFusion,
  setReceiverPowerPlacementId,
  setReceiverPowerModalOpen,
  setReceiverPowerError,
  spawnText,
  playerPos,
  activeBerryFusionStations,
  ghostDecor,
  canPlaceGhost,
  decorPlacements,
  handleRemovePlacement,
  exitTrainerNpcMode,
  setDecorMoveMode,
  setSelectedDecor,
  setMouseGhostPos,
  setDecorRemoveMode,
  handlePlaceDecorAt,
}) {
  if (!isMyIsland) return null;

  return (
    <>
      {(placingDecor || (decorMoveMode && selectedMovePlacementId)) && !decorRemoveMode && (
        <div
          onMouseMove={handlePlacementMouseMove}
          onClick={handlePlacementMapClick}
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: VIEWPORT_WIDTH,
            height: VIEWPORT_HEIGHT,
            zIndex: 9998,
            background: "transparent",
            pointerEvents: "auto",
            cursor: (decorMoveMode && selectedMovePlacementId) ? "crosshair" : (canPlaceGhost ? "crosshair" : "not-allowed"),
          }}
        />
      )}

      {trainerNpcMode === "move" && !placingDecor && !decorRemoveMode && (
        <div
          onClick={handleTrainerNpcMapClick}
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: VIEWPORT_WIDTH,
            height: VIEWPORT_HEIGHT,
            zIndex: 9997,
            background: "transparent",
            pointerEvents: "auto",
            cursor: "crosshair",
          }}
        />
      )}

      {gameCornerNpcMode === "move" && !placingDecor && !decorRemoveMode && (
        <div
          onClick={handleGameCornerNpcMapClick}
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: VIEWPORT_WIDTH,
            height: VIEWPORT_HEIGHT,
            zIndex: 9997,
            background: "transparent",
            pointerEvents: "auto",
            cursor: "crosshair",
          }}
        />
      )}

      {(sortedDecorPlacements || []).map((p) => {
        const screenX = (Number(p?.x) || 0) - camX;
        const screenY = (Number(p?.y) || 0) - camY;
        const w = Number(p?.sprite_w) || 16;
        const h = Number(p?.sprite_h) || 16;
        const isFlowers = String(p?.decor_key || "") === "flowers" || String(p?.sprite_path || "").includes("/flowers.png");
        const isFountain = String(p?.decor_key || "") === "fountain" || String(p?.sprite_path || "").includes("/fountain.png");
        const isCrater = String(p?.decor_key || "") === "crater";
        const isSpawnPoint = String(p?.decor_key || "") === "spawn-point";
        const isReceiver = String(p?.decor_key || "") === "reciever";
        const isDrill = String(p?.decor_key || "") === "drill";
        const isHut = ["hut", "junglehut", "tinyhome"].includes(String(p?.decor_key || ""));
        const isFarmingShop = String(p?.decor_key || "") === "farmingshop";
        const isBerryFusion = String(p?.decor_key || "") === "berryfusion";
        const powerReceivers = receiverPowerModalOpen
          ? (receiverPowerStatus?.receivers || [])
          : (receiverWorldPowerStatus?.receivers || []);
        const receiverRow = isReceiver
          ? powerReceivers.find((r) => Number(r?.receiver_placement_id) === Number(p?.placement_id))
          : null;
        const receiverActive = Boolean(receiverRow?.pokemon_id) && Number(receiverRow?.pokemon_id) > 0;
        const poweredDrills = receiverWorldPowerStatus?.powered_drills || [];
        const drillPowered = isDrill && poweredDrills.includes(Number(p?.placement_id));
        const poweredBerryFusion = receiverWorldPowerStatus?.powered_berryfusion || [];
        const berryFusionPowered = isBerryFusion && poweredBerryFusion.includes(Number(p?.placement_id));
        const berryFusionActive = berryFusionPowered && activeBerryFusionStations.has(String(p?.placement_id));
        const isSelectedForRemoval = Number(selectedRemovalPlacementId) === Number(p?.placement_id);
        const isAssigningHere = (trainerNpcMode === "assign" || gameCornerNpcMode === "assign") && isHut;

        if (screenX < -w || screenX > VIEWPORT_WIDTH + w || screenY < -h || screenY > VIEWPORT_HEIGHT + h) {
          return null;
        }

        const spriteBottom = (Number(p?.y) || 0) + h;
        const collisionBottom =
          (Number(p?.y) || 0) +
          (Number(p?.collision_y) || 0) +
          (Number(p?.collision_h) || 0);
        const feetY = Math.max(spriteBottom, collisionBottom);
        const zIndex = (isCrater || isSpawnPoint) ? myIslandZBase + 1 : myIslandZBase + Math.round(Number(feetY) || 0);

        const farmMeta = isFarmingShop
          ? (berryShopPower.byShopPlacementId?.[Number(p?.placement_id) || 0] || null)
          : null;
        const farmPowered = farmMeta ? Boolean(farmMeta.powered) : true;

        return (
          <div
            key={`decor-${p.placement_id}`}
            onClick={(e) => {
              e?.stopPropagation?.();
              if (isAssigningHere) {
                handleHutClickForAssignment(p);
                return;
              }
              if (decorRemoveMode) {
                setSelectedRemovalPlacementId(Number(p?.placement_id) || null);
                return;
              }
              if (decorMoveMode) {
                setSelectedMovePlacementId(Number(p?.placement_id) || null);
                setMovingDecor(p);
                return;
              }
              if (isDrill) {
                setDrillPlacementId(Number(p?.placement_id) || null);
                setDrillModalOpen(true);
                return;
              }
              if (isBerryFusion) {
                if (!berryFusionPowered) {
                  spawnText('Berry Fusion needs power!', playerPos.x, playerPos.y - 16, 'red');
                  return;
                }
                setActiveBerryFusionStationId(String(p?.placement_id || ""));
                setShowBerryFusion(true);
                return;
              }
              if (!isReceiver) return;
              setReceiverPowerPlacementId(Number(p?.placement_id) || null);
              setReceiverPowerModalOpen(true);
              setReceiverPowerError(null);
            }}
            style={{
              position: "absolute",
              left: screenX,
              top: screenY,
              width: w,
              height: h,
              overflow: "visible",
              backgroundImage: `url(${p.sprite_path})`,
              backgroundSize: isFlowers ? "80px 16px" : isFountain ? `${w * 5}px ${h}px` : `${w}px ${h}px`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: isFlowers || isFountain ? "0 0" : undefined,
              ...(isFlowers ? { animation: "flowersAnim 0.9s steps(5) infinite" } : isFountain ? { animation: "flowersAnim 1.05s steps(5) infinite", ["--flowers-sheet-end"]: `-${w * 5}px` } : null),
              imageRendering: "pixelated",
              zIndex,
              opacity: (isFarmingShop && !farmPowered) || (isBerryFusion && !berryFusionPowered) || (decorMoveMode && selectedMovePlacementId === Number(p?.placement_id)) ? 0.55 : 1,
              pointerEvents: decorRemoveMode || decorMoveMode || isReceiver || isDrill || isBerryFusion || isAssigningHere ? "auto" : "none",
              outline: isSelectedForRemoval ? "2px solid rgba(239,68,68,0.95)" : (decorMoveMode && selectedMovePlacementId === Number(p?.placement_id)) ? "2px solid rgba(59,130,246,0.95)" : "none",
              outlineOffset: 1,
              filter: isSelectedForRemoval
                ? "drop-shadow(0 0 4px rgba(239,68,68,0.8))"
                : (decorMoveMode && selectedMovePlacementId === Number(p?.placement_id))
                ? "drop-shadow(0 0 4px rgba(59,130,246,0.8))"
                : (isFarmingShop && !farmPowered ? "grayscale(1) brightness(0.75)" : undefined),
              cursor: decorRemoveMode || decorMoveMode || isReceiver || isDrill || isAssigningHere ? "pointer" : "default",
            }}
          >
            {isDrill && drillPowered && (
              <>
                {[...Array(3)].map((_, i) => (
                  <div
                    key={`steam-${i}`}
                    style={{
                      position: "absolute",
                      left: `${30 + i * 15}%`,
                      bottom: "80%",
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      background: "rgba(200, 200, 200, 0.6)",
                      animation: `steamRise ${1.5 + i * 0.3}s ease-in-out infinite`,
                      animationDelay: `${i * 0.5}s`,
                      pointerEvents: "none",
                    }}
                  />
                ))}
              </>
            )}
            {isBerryFusion && berryFusionActive && (
              <div className="berry-fusion-anim" style={{ zIndex: zIndex + 5 }}>
                <div className="berry-fusion-core" />
                {[...Array(5)].map((_, i) => (
                  <div
                    key={`fusion-orb-${i}`}
                    className="berry-fusion-orb"
                    style={{
                      left: `${18 + i * 14}%`,
                      animationDelay: `${i * 0.35}s`,
                      animationDuration: `${1.8 + i * 0.2}s`,
                      background: i % 2 === 0 ? "rgba(255, 152, 200, 0.9)" : "rgba(255, 219, 128, 0.9)",
                      boxShadow: i % 2 === 0 ? "0 0 8px rgba(255, 152, 200, 0.7)" : "0 0 8px rgba(255, 219, 128, 0.7)",
                    }}
                  />
                ))}
              </div>
            )}
            {isHut && (() => {
              const hutPlacementId = Number(p?.placement_id) || 0;
              const assignedTrainerNpc = ownedTrainerNpcs.find(
                (npc) => Number(npc?.hut_placement_id) === hutPlacementId
              );
              const assignedGameCornerNpc = ownedGameCornerNpcs.find(
                (npc) => Number(npc?.hut_placement_id) === hutPlacementId
              );
              const assignedNpc = assignedTrainerNpc || assignedGameCornerNpc;

              if (!assignedNpc) return null;

              const npcName = assignedNpc?.trainer_name || assignedNpc?.npc_name || "NPC";

              return (
                <div
                  style={{
                    position: "absolute",
                    bottom: "100%",
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "rgba(0, 0, 0, 0.8)",
                    color: "white",
                    padding: "2px 6px",
                    borderRadius: "4px",
                    fontSize: "10px",
                    fontWeight: "bold",
                    whiteSpace: "nowrap",
                    pointerEvents: "none",
                    marginBottom: "2px",
                    zIndex: 1000,
                  }}
                >
                  {npcName}
                </div>
              );
            })()}
            {isReceiver && receiverActive && (
              <>
                {[...Array(4)].map((_, i) => (
                  <div
                    key={`receiver-energy-${i}`}
                    style={{
                      position: "absolute",
                      left: `${20 + i * 18}%`,
                      bottom: "75%",
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      background: i % 2 === 0 ? "rgba(250, 204, 21, 0.9)" : "rgba(253, 224, 71, 0.9)",
                      boxShadow: i % 2 === 0 ? "0 0 8px rgba(250, 204, 21, 0.7)" : "0 0 8px rgba(253, 224, 71, 0.7)",
                      animation: `receiverEnergyFloat ${1.8 + i * 0.3}s ease-in-out infinite`,
                      animationDelay: `${i * 0.4}s`,
                      pointerEvents: "none",
                    }}
                  />
                ))}
              </>
            )}
          </div>
        );
      })}

      {ghostDecor && (
        (() => {
          const isFlowers =
            String(ghostDecor?.decor_key || "") === "flowers" ||
            String(ghostDecor?.sprite_path || "").includes("/flowers.png");
          const isFountain =
            String(ghostDecor?.decor_key || "") === "fountain" ||
            String(ghostDecor?.sprite_path || "").includes("/fountain.png");

          return (
            <div
              style={{
                position: "absolute",
                left: (Number(ghostDecor.x) || 0) - camX,
                top: (Number(ghostDecor.y) || 0) - camY,
                width: Number(ghostDecor.sprite_w) || 16,
                height: Number(ghostDecor.sprite_h) || 16,
                backgroundImage: `url(${ghostDecor.sprite_path})`,
                backgroundSize: isFlowers
                  ? "80px 16px"
                  : isFountain
                    ? `${(Number(ghostDecor.sprite_w) || 16) * 5}px ${Number(ghostDecor.sprite_h) || 16}px`
                    : `${Number(ghostDecor.sprite_w) || 16}px ${Number(ghostDecor.sprite_h) || 16}px`,
                backgroundRepeat: "no-repeat",
                ...(isFlowers
                  ? { animation: "flowersAnim 0.9s steps(5) infinite" }
                  : isFountain
                    ? { animation: "flowersAnim 1.05s steps(5) infinite", ["--flowers-sheet-end"]: `-${(Number(ghostDecor.sprite_w) || 16) * 5}px` }
                    : null),
                imageRendering: "pixelated",
                zIndex: myIslandZBase + Math.round((Number(ghostDecor.y) || 0) + (Number(ghostDecor.sprite_h) || 16)) + 1,
                pointerEvents: "none",
                opacity: canPlaceGhost ? 0.45 : 0.35,
                filter: canPlaceGhost ? "grayscale(1)" : "grayscale(1) drop-shadow(0 0 2px rgba(248,113,113,0.7))",
                outline: canPlaceGhost ? "1px dashed rgba(255,255,255,0.25)" : "1px dashed rgba(248,113,113,0.65)",
                outlineOffset: -1,
              }}
            />
          );
        })()
      )}

      {(placingDecor || decorRemoveMode || trainerNpcMode) && (
        <div
          style={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 9999,
            display: "flex",
            gap: 8,
            pointerEvents: "auto",
          }}
        >
          {trainerNpcMode && (
            <button
              onClick={() => {
                exitTrainerNpcMode();
              }}
              style={{
                background: "rgba(239, 68, 68, 0.16)",
                border: "1px solid rgba(239, 68, 68, 0.75)",
                color: "#fff",
                borderRadius: 10,
                padding: "8px 12px",
                cursor: "pointer",
                fontWeight: 900,
                fontSize: 12,
                backdropFilter: "blur(4px)",
              }}
              title="Cancel"
            >
              Cancel
            </button>
          )}

          {!decorRemoveMode && !decorMoveMode && (
            <>
              <button
                onClick={() => {
                  setDecorMoveMode(true);
                  setSelectedDecor(null);
                  setMouseGhostPos(null);
                  setSelectedMovePlacementId(null);
                  setMovingDecor(null);
                }}
                style={{
                  background: "rgba(59,130,246,0.12)",
                  border: "1px solid rgba(59,130,246,0.75)",
                  color: "#fff",
                  borderRadius: 10,
                  padding: "8px 12px",
                  cursor: "pointer",
                  fontWeight: 900,
                  fontSize: 12,
                  backdropFilter: "blur(4px)",
                }}
                title="Move existing decor"
              >
                Move Mode
              </button>
              <button
                onClick={() => {
                  setDecorRemoveMode(true);
                  setSelectedDecor(null);
                  setMouseGhostPos(null);
                  setSelectedRemovalPlacementId(null);
                }}
                style={{
                  background: "rgba(239,68,68,0.12)",
                  border: "1px solid rgba(239,68,68,0.75)",
                  color: "#fff",
                  borderRadius: 10,
                  padding: "8px 12px",
                  cursor: "pointer",
                  fontWeight: 900,
                  fontSize: 12,
                  backdropFilter: "blur(4px)",
                }}
                title="Remove decor"
              >
                Remove Mode
              </button>
            </>
          )}

          {decorMoveMode && (
            <button
              onClick={() => {
                setDecorMoveMode(false);
                setSelectedMovePlacementId(null);
                setMovingDecor(null);
              }}
              style={{
                background: "rgba(59,130,246,0.24)",
                border: "1px solid rgba(59,130,246,0.75)",
                color: "#fff",
                borderRadius: 10,
                padding: "8px 12px",
                cursor: "pointer",
                fontWeight: 900,
                fontSize: 12,
                backdropFilter: "blur(4px)",
              }}
            >
              {selectedMovePlacementId ? 'Cancel Move' : 'Exit Move Mode'}
            </button>
          )}

          {decorRemoveMode && Boolean(selectedRemovalPlacementId) && (
            <button
              onClick={() => {
                const target = (decorPlacements || []).find(
                  (p) => Number(p?.placement_id) === Number(selectedRemovalPlacementId)
                );
                if (!target) return;
                handleRemovePlacement(target);
                setSelectedRemovalPlacementId(null);
              }}
              style={{
                background: "rgba(239,68,68,0.24)",
                border: "1px solid rgba(239,68,68,0.75)",
                color: "#fff",
                borderRadius: 10,
                padding: "8px 12px",
                cursor: "pointer",
                fontWeight: 900,
                fontSize: 12,
                backdropFilter: "blur(4px)",
              }}
            >
              Remove Selected
            </button>
          )}

          {!decorRemoveMode && placingDecor && (
            <button
              onClick={() => {
                if (!ghostDecor) return;
                if (!canPlaceGhost) {
                  spawnText("Cannot place here", ghostDecor.x, ghostDecor.y - 12, "#f87171");
                  return;
                }
                handlePlaceDecorAt(ghostDecor.x, ghostDecor.y);
              }}
              disabled={!ghostDecor || !canPlaceGhost}
              style={{
                background: canPlaceGhost ? "rgba(34, 197, 94, 0.22)" : "rgba(34, 197, 94, 0.10)",
                border: "1px solid rgba(34, 197, 94, 0.75)",
                color: "#fff",
                borderRadius: 10,
                padding: "8px 12px",
                cursor: ghostDecor && canPlaceGhost ? "pointer" : "not-allowed",
                fontWeight: 900,
                fontSize: 12,
                opacity: ghostDecor && canPlaceGhost ? 1 : 0.55,
                backdropFilter: "blur(4px)",
              }}
              title={canPlaceGhost ? "Place" : "Cannot place here"}
            >
              Place
            </button>
          )}

          <button
            onClick={() => {
              setSelectedDecor(null);
              setMouseGhostPos(null);
              setDecorRemoveMode(false);
              setSelectedRemovalPlacementId(null);
              exitTrainerNpcMode();
            }}
            style={{
              background: "rgba(239, 68, 68, 0.16)",
              border: "1px solid rgba(239, 68, 68, 0.75)",
              color: "#fff",
              borderRadius: 10,
              padding: "8px 12px",
              cursor: "pointer",
              fontWeight: 900,
              fontSize: 12,
              backdropFilter: "blur(4px)",
            }}
            title="Exit"
          >
            Exit
          </button>
        </div>
      )}
    </>
  );
}
